var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('div', {
    slot: "header"
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (3),
      expression: "3",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (3),
      expression: "3",
      modifiers: {
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('div', [_c('v-text', {
    attrs: {
      "type": "title"
    }
  }, [_vm._v("\n                        Идентификация\n                    ")])], 1), _vm._v(" "), _c('v-text', {
    attrs: {
      "type": "text",
      "danger": ""
    }
  }, [_vm._v("\n                    Внесите идентификационный платеж от 2500 рублей с расчетного счета \n                    организации или индивидуальрого предпринимателя (пункт 3.1.2 в оферте). \n                    Выбранный Тариф будет активирован автоматически.\n                ")])], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2f21810","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/contractElectronic/ContractElectronic.vue
// module id = 925
// module chunks = 0